import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-137">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-138">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="bg-cream rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden border border-sage/20" data-id="element-139">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-sage/20 bg-white" data-id="element-140">
              <h3 className="font-serif text-xl md:text-2xl text-charcoal" data-id="element-141">
                {title}
              </h3>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 rounded-full flex items-center justify-center text-charcoal/60 hover:bg-sage/10 hover:text-charcoal transition-colors" data-id="element-142">
                <X size={20} data-id="element-143" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-8 py-6 font-sans text-charcoal/80 text-base leading-relaxed space-y-4" data-id="element-144">
              {children}
            </div>

            {/* Footer */}
            <div className="px-6 md:px-8 py-4 border-t border-sage/20 bg-white flex justify-end" data-id="element-145">
              <button onClick={onClose} className="bg-terracotta text-cream font-sans font-semibold py-2.5 px-6 rounded-full hover:bg-opacity-90 transition-colors" data-id="element-146">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}